// extracted by mini-css-extract-plugin
module.exports = {"footer":"MiniContactPanel_footer__h6IcD","divider":"MiniContactPanel_divider__VM2FK","stickyNav":"MiniContactPanel_stickyNav__QzB6V","text":"MiniContactPanel_text___tfyS"};